// import React, { useState } from "react";
// import qs from "query-string";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useFetchData } from "../../hooks/useFtechData";
// import { JOBSEEKER_URL } from "../../resources/resource";
// import Header from "../../component/Header";
// import { nigeriaStates, workTypes } from "../../assets/jobData";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { candidateSearchSchema } from "../../validation/auth";
// import CandidateCard from "./candidateCard";
// import {
//   BiSearch,
//   BiFilter,
//   BiBriefcase,
//   BiMapPin,
//   BiUser,
//   BiChevronDown,
//   BiChevronUp,
// } from "react-icons/bi";
// import FooterComponent from "../../component/Footer";
// import AdvanceSearch from "./advanceSearch";
// import { CgMoreVertical } from "react-icons/cg";
// import { getEmployees } from "./data";
// import GeneralModal from "../../component/Modals/General.modal";
// import ViewCandidate from "./ViewCandidate";

// const Candidate = () => {
//   const location = useLocation();
//   const { jobTitle, workType, state } = qs.parse(location.search);
//   const makeRequest = useMakeRequest();
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const [showAdvance, setShowAdvance] = useState(false);
//   const [advanceSearch, setAdvanceSearch] = useState({});
//   const [loadingAdvance, setLoadingAdvance] = useState(false);
//   const [searchResult, setSearchResult] = useState(null);
//   const [activeUser, setActiveUser] = useState(null);
//   const [activeData, setActiveData] = useState(null);
//   const [showModal, setshowModal] = useState(false);
//   const [advanceResult, setAdvanceResult] = useState(null);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(candidateSearchSchema),
//     defaultValues: {
//       jobTitle: jobTitle || "",
//       jobType: workType || workTypes[0],
//       state: state || nigeriaStates[0],
//     },
//   });

//   // const state = watch("state");

//   const {
//     data: candidateData,
//     loading,
//     errors: candidateError,
//   } = useFetchData(
//     JOBSEEKER_URL +
//       `/search?jobTitle=${jobTitle || ""}&workType=${workType || ""}&state=${
//         state || ""
//       }`
//   );

//   const onSubmit = (data) => {
//     // console.log("data gotten -->", data);
//     // Here you would typically redirect with new search params
//   };

//   const navigate = useNavigate();

//   const toggleFilters = () => {
//     setIsFilterOpen(!isFilterOpen);
//   };

//   const handleAdvance = () => {
//     setLoadingAdvance(true);
//     const onSuccess = (data) => {
//       setSearchResult(data);
//       setAdvanceResult(data?.length);
//     };
//     // --- make request ---
//     makeRequest(
//       JOBSEEKER_URL + "/advance_search",
//       "POST",
//       advanceSearch,
//       onSuccess,
//       console.log,
//       () => {
//         setLoadingAdvance(false);
//       }
//     );
//   };

//   const handleMore = (userData) => {
//     const id = userData?.id;
//     if (activeUser === id) return setActiveUser(null);
//     setActiveUser(id);
//     setActiveData(userData);
//   };
//   const handleView = (userId) => {
//     // navigate(`/employee_profile/${userId}`);2
//     navigate(`/advance_candidate`, { state: { activeData } });
//     setshowModal(true);
//   };

//   // const handleViewMessage = (email) => {
//   //   // console.log("mail -->", email);
//   //   const mailToUrl = `mailTo:${email}`;
//   //   window.location.href = mailToUrl;
//   // };

//   // console.log("result -->", searchResult);

//   return (
//     <div className="min-h-screen bg-gray-50 pt-16 sm:pt-20">
//       <Header darkMode={false} />

//       {/* Hero Section */}
//       <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-12 px-4">
//         <div className="container mx-auto text-center">
//           <h1 className="text-3xl md:text-4xl font-bold mb-4">
//             Find Top Talent
//           </h1>
//           <p className="text-lg md:text-xl max-w-2xl mx-auto opacity-90">
//             Discover qualified candidates matching your job requirements and
//             build your dream team.
//           </p>
//         </div>
//       </div>

//       {/* Search Section */}
//       <div className="container mx-auto px-4 py-6 -mt-8">
//         <div className="bg-white rounded-lg shadow-lg p-6">
//           <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
//             <div className="relative">
//               <input
//                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
//                 type="text"
//                 placeholder="Search for skills, job titles, or keywords..."
//                 {...register("jobTitle")}
//               />
//               <BiSearch className="absolute left-3 top-3.5 text-gray-400 text-xl" />

//               <button
//                 type="button"
//                 onClick={toggleFilters}
//                 className="md:hidden absolute right-3 top-3 text-gray-500"
//               >
//                 <BiFilter className="text-xl" />
//               </button>
//             </div>

//             {/* Error message for job title */}
//             {errors.jobTitle && (
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.jobTitle.message}
//               </p>
//             )}

//             {/* Desktop Filters - Always visible on md+ screens */}
//             <div className="hidden md:flex gap-4 items-center">
//               <div className="flex-1 relative">
//                 <div className="absolute left-3 top-3 text-gray-400">
//                   <BiBriefcase />
//                 </div>
//                 <select
//                   {...register("jobType")}
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
//                 >
//                   <option value="">All Work Types</option>
//                   {workTypes?.map((jobType, index) => (
//                     <option key={index} value={jobType}>
//                       {jobType}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex-1 relative">
//                 <div className="absolute left-3 top-3 text-gray-400">
//                   <BiMapPin />
//                 </div>
//                 <select
//                   {...register("state")}
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
//                 >
//                   <option value="">All States</option>
//                   {nigeriaStates?.map((state, index) => (
//                     <option key={index} value={state}>
//                       {state}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <button
//                 type="submit"
//                 className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium flex items-center justify-center"
//               >
//                 <BiSearch className="mr-2" />
//                 Search
//               </button>
//             </div>

//             {/* Mobile Filters - Toggle visibility */}
//             <div
//               className={`md:hidden space-y-3 ${
//                 isFilterOpen ? "block" : "hidden"
//               }`}
//             >
//               <div className="relative">
//                 <div className="absolute left-3 top-3 text-gray-400">
//                   <BiBriefcase />
//                 </div>
//                 <select
//                   {...register("jobType")}
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
//                 >
//                   <option value="">All Work Types</option>
//                   {workTypes?.map((jobType, index) => (
//                     <option key={index} value={jobType}>
//                       {jobType}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="relative">
//                 <div className="absolute left-3 top-3 text-gray-400">
//                   <BiMapPin />
//                 </div>
//                 <select
//                   {...register("state")}
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
//                 >
//                   <option value="">All States</option>
//                   {nigeriaStates?.map((state, index) => (
//                     <option key={index} value={state}>
//                       {state}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Mobile Search Button */}
//             <div className="md:hidden">
//               <button
//                 type="submit"
//                 className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium flex items-center justify-center"
//               >
//                 <BiSearch className="mr-2" />
//                 Search
//               </button>
//             </div>
//           </form>
//         </div>
//         {showAdvance ? (
//           <AdvanceSearch
//             handler={() => {
//               setShowAdvance(false);
//             }}
//             state={state}
//             setFormState={setAdvanceSearch}
//             formState={advanceSearch}
//             submit={handleAdvance}
//             loading={loadingAdvance}
//           />
//         ) : (
//           <button
//             className="mt-5 bg-orange-500 p-2 rounded-sm text-white flex items-center justify-center gap-2"
//             onClick={() => {
//               setShowAdvance(true);
//             }}
//           >
//             {showAdvance ? <BiChevronDown /> : <BiChevronUp />}
//             Advance Search
//           </button>
//         )}
//       </div>

//       {/* Results Section */}
//       <div className="container mx-auto px-4 py-8 mb-40">
//         {/* Results Header */}
//         <div className="flex items-center justify-between mb-6">
//           {!advanceResult ? (
//             <h2 className="text-xl font-semibold text-gray-800">
//               {loading
//                 ? "Searching for candidates..."
//                 : candidateData?.length
//                 ? `Found ${candidateData.length} matching candidates`
//                 : "No candidates match your search"}
//             </h2>
//           ) : null}
//           <h2 className="text-xl font-semibold text-gray-800">
//             {advanceResult ? `Found ${advanceResult} advance result` : null}
//           </h2>

//           <div className="flex items-center gap-2">
//             <span className="text-sm text-gray-600">Sort by:</span>
//             <select className="border border-gray-300 rounded px-3 py-1 text-sm">
//               <option value="relevance">Relevance</option>
//               <option value="recent">Most Recent</option>
//               <option value="experience">Experience</option>
//             </select>
//           </div>
//         </div>

//         {/* Loading State */}
//         {loading && (
//           <div className="text-center py-12">
//             <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-4"></div>
//             <p className="text-gray-600">
//               Searching for qualified candidates...
//             </p>
//           </div>
//         )}

//         {/* Error State */}
//         {candidateError && (
//           <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
//             <div className="flex items-center">
//               <div className="text-red-500">
//                 <svg
//                   className="h-5 w-5"
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 20 20"
//                   fill="currentColor"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </div>
//               <div className="ml-3">
//                 <p className="text-sm text-red-700">
//                   Unable to load candidates. Please try again later.
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="w-full overflow-x-auto ">
//           {searchResult?.length ? (
//             <table className="w-full min-w-max">
//               <thead className="text-gray-800 text-sm">
//                 <tr className="text-sm">
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     S/N
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Full Name
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Email
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Address
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Unemployment (length)
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Job Type
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Candidate Type
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     Applications
//                   </th>
//                   <th className="py-3 px-4 text-start whitespace-nowrap">
//                     <CgMoreVertical className="text-gray-700" />
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {getEmployees(searchResult)?.map((user, index) => (
//                   <tr
//                     key={user.id}
//                     className="text-gray-700 text-sm text-start"
//                   >
//                     <td className="py-3 px-4 text-center whitespace-nowrap">
//                       {index + 1}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       {user.fullName}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       {user.email}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       {user.address}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       1 year
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       job change
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       {user?.workExperience?.length > 0
//                         ? "Experience"
//                         : "Fresh Graduate"}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap">
//                       {user.applications}
//                     </td>
//                     <td className="py-3 px-4 text-start whitespace-nowrap relative">
//                       <button
//                         onClick={() => handleMore(user)}
//                         className="hover:bg-gray-100 rounded-full"
//                       >
//                         <CgMoreVertical />
//                       </button>

//                       {activeUser === user?.id && (
//                         <ul className="absolute top-6 right-12 w-36 bg-white shadow-md rounded-lg px-2 py-1 transform transition-all duration-200 ease-in-out animate-dropdown">
//                           <li
//                             onClick={() => handleView(user?.id)}
//                             className="cursor-pointer hover:text-blue-200 mb-2 p-2"
//                           >
//                             view
//                           </li>
//                         </ul>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : null}
//         </div>

//         {/* basic search */}
//         {!loading && !candidateError && searchResult === null && (
//           <div className="flex items-start justify-center gap-6 flex-wrap">
//             {candidateData?.length ? (
//               candidateData.map((data, index) => (
//                 <CandidateCard seeker={data} key={index} />
//               ))
//             ) : (
//               <div className="col-span-full text-center py-12">
//                 <BiUser className="mx-auto h-16 w-16 text-gray-300" />
//                 <h3 className="mt-4 text-lg font-medium text-gray-900">
//                   No candidates found
//                 </h3>
//                 <p className="mt-1 text-gray-500">
//                   Try adjusting your search filters for more results.
//                 </p>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       <FooterComponent />
//     </div>
//   );
// };

// export default Candidate;



// --- Key fixes applied (search this file for "FIX:" comments) ---

import React, { useState } from "react";
import qs from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchData } from "../../hooks/useFtechData";
import { JOBSEEKER_URL } from "../../resources/resource";
import Header from "../../component/Header";
import { nigeriaStates, workTypes } from "../../assets/jobData";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { candidateSearchSchema } from "../../validation/auth";
import CandidateCard from "./candidateCard";
import {
  BiSearch,
  BiFilter,
  BiBriefcase,
  BiMapPin,
  BiUser,
  BiChevronDown,
  BiChevronUp,
} from "react-icons/bi";
import FooterComponent from "../../component/Footer";
import AdvanceSearch from "./advanceSearch";
import { CgMoreVertical } from "react-icons/cg";
import { getEmployees } from "./data";

const Candidate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { jobTitle, workType, state, fullName } = qs.parse(location.search);
  const makeRequest = useMakeRequest();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showAdvance, setShowAdvance] = useState(false);
  const [advanceSearch, setAdvanceSearch] = useState({});
  const [loadingAdvance, setLoadingAdvance] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [activeData, setActiveData] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const [advanceResult, setAdvanceResult] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(candidateSearchSchema),
    defaultValues: {
      // FIX: default to "" so the "All ..." option is genuinely selected
      // until the user actively picks something. Using workTypes[0] /
      // nigeriaStates[0] silently applied a real filter on first render.
      jobTitle: jobTitle || "",
      jobType: workType || "",
      state: state || "",
      fullName: fullName || "",
    },
  });

  // FIX: only fetch when at least one real search param is present in
  // the URL. This avoids hitting the backend's "provide at least one
  // search parameter" guard on every fresh page load, which previously
  // produced a permanent error banner before the user searched at all.
  const hasSearchParams = Boolean(jobTitle || workType || state || fullName);

  // FIX: build the query string with qs.stringify instead of raw
  // template-literal concatenation, so values with spaces/special
  // characters (e.g. "Akwa Ibom") don't corrupt the URL.
  const searchQuery = qs.stringify({
    jobTitle: jobTitle || undefined,
    workType: workType || undefined,
    state: state || undefined,
    fullName: fullName || undefined,
  });

  const {
    data: candidateData,
    loading,
    errors: candidateError,
  } = useFetchData(
    hasSearchParams ? `${JOBSEEKER_URL}/search?${searchQuery}` : null
  );

  const onSubmit = (data) => {
    navigate(
      `?${qs.stringify({
        jobTitle: data.jobTitle || undefined,
        workType: data.jobType || undefined,
        state: data.state || undefined,
        fullName: data.fullName || undefined,
      })}`
    );
  };

  const toggleFilters = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleAdvance = () => {
    setLoadingAdvance(true);
    const onSuccess = (data) => {
      setSearchResult(data);
      setAdvanceResult(data?.length);
    };
    makeRequest(
      JOBSEEKER_URL + "/advance_search",
      "POST",
      advanceSearch,
      onSuccess,
      console.log,
      () => {
        setLoadingAdvance(false);
      }
    );
  };

  const handleMore = (userData) => {
    const id = userData?.id;
    if (activeUser === id) return setActiveUser(null);
    setActiveUser(id);
    setActiveData(userData);
  };

  const handleView = (userId) => {
    navigate(`/advance_candidate`, { state: { activeData } });
    setshowModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-16 sm:pt-20">
      <Header darkMode={false} />

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-12 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Find Top Talent</h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto opacity-90">
            Discover qualified candidates matching your job requirements and
            build your dream team.
          </p>
        </div>
      </div>

      {/* Search Section */}
      <div className="container mx-auto px-4 py-6 -mt-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div className="relative">
              <input
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                type="text"
                placeholder="Search for skills, job titles, or keywords..."
                {...register("jobTitle")}
              />
              <BiSearch className="absolute left-3 top-3.5 text-gray-400 text-xl" />
              <button
                type="button"
                onClick={toggleFilters}
                className="md:hidden absolute right-3 top-3 text-gray-500"
              >
                <BiFilter className="text-xl" />
              </button>
            </div>

            {errors.jobTitle && (
              <p className="text-red-500 text-sm mt-1">{errors.jobTitle.message}</p>
            )}

            <div className="relative">
              <BiUser className="absolute left-3 top-3.5 text-gray-400 text-lg" />
              <input
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                type="text"
                placeholder="Search by full name..."
                {...register("fullName")}
              />
            </div>

            {/* Filters — rendered ONCE. Visibility toggles responsively
                instead of duplicating the <select> elements, which
                previously caused react-hook-form to read the value from
                whichever select was registered last (not the one the
                user actually interacted with). */}
            <div
              className={`${
                isFilterOpen ? "flex" : "hidden"
              } md:flex flex-col md:flex-row gap-3 md:gap-4 md:items-center`}
            >
              <div className="flex-1 relative">
                <div className="absolute left-3 top-3 text-gray-400">
                  <BiBriefcase />
                </div>
                <select
                  {...register("jobType")}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                >
                  <option value="">All Work Types</option>
                  {workTypes?.map((jobType, index) => (
                    <option key={index} value={jobType}>
                      {jobType}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex-1 relative">
                <div className="absolute left-3 top-3 text-gray-400">
                  <BiMapPin />
                </div>
                <select
                  {...register("state")}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                >
                  <option value="">All States</option>
                  {nigeriaStates?.map((s, index) => (
                    <option key={index} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              {/* Desktop search button lives inline with the filters;
                  mobile gets its own full-width button below. */}
              <button
                type="submit"
                className="hidden md:flex px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium items-center justify-center"
              >
                <BiSearch className="mr-2" />
                Search
              </button>
            </div>

            <div className="md:hidden">
              <button
                type="submit"
                className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium flex items-center justify-center"
              >
                <BiSearch className="mr-2" />
                Search
              </button>
            </div>
          </form>
        </div>

        {showAdvance ? (
          <AdvanceSearch
            handler={() => setShowAdvance(false)}
            state={state}
            setFormState={setAdvanceSearch}
            formState={advanceSearch}
            submit={handleAdvance}
            loading={loadingAdvance}
          />
        ) : (
          <button
            className="mt-5 bg-orange-500 p-2 rounded-sm text-white flex items-center justify-center gap-2"
            onClick={() => setShowAdvance(true)}
          >
            {showAdvance ? <BiChevronDown /> : <BiChevronUp />}
            Advance Search
          </button>
        )}
      </div>

      {/* Results Section */}
      <div className="container mx-auto px-4 py-8 mb-40">
        <div className="flex items-center justify-between mb-6">
          {!advanceResult ? (
            <h2 className="text-xl font-semibold text-gray-800">
              {!hasSearchParams
                ? "Enter a search filter above to find candidates"
                : loading
                ? "Searching for candidates..."
                : candidateData?.length
                ? `Found ${candidateData.length} matching candidates`
                : "No candidates match your search"}
            </h2>
          ) : null}
          <h2 className="text-xl font-semibold text-gray-800">
            {advanceResult ? `Found ${advanceResult} advance result` : null}
          </h2>

          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Sort by:</span>
            <select className="border border-gray-300 rounded px-3 py-1 text-sm">
              <option value="relevance">Relevance</option>
              <option value="recent">Most Recent</option>
              <option value="experience">Experience</option>
            </select>
          </div>
        </div>

        {loading && (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-4"></div>
            <p className="text-gray-600">Searching for qualified candidates...</p>
          </div>
        )}

        {/* FIX: only render the error banner when a search was actually
            attempted — otherwise it shows permanently on first load. */}
        {hasSearchParams && candidateError && (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
            <div className="flex items-center">
              <div className="text-red-500">
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  Unable to load candidates. Please try again later.
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="w-full overflow-x-auto ">
          {searchResult?.length ? (
            <table className="w-full min-w-max">
              <thead className="text-gray-800 text-sm">
                <tr className="text-sm">
                  <th className="py-3 px-4 text-start whitespace-nowrap">S/N</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Full Name</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Email</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Address</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Unemployment (length)</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Job Type</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Candidate Type</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">Applications</th>
                  <th className="py-3 px-4 text-start whitespace-nowrap">
                    <CgMoreVertical className="text-gray-700" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {getEmployees(searchResult)?.map((user, index) => (
                  <tr key={user.id} className="text-gray-700 text-sm text-start">
                    <td className="py-3 px-4 text-center whitespace-nowrap">{index + 1}</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">{user.fullName}</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">{user.email}</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">{user.address}</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">1 year</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">job change</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">
                      {user?.workExperience?.length > 0 ? "Experience" : "Fresh Graduate"}
                    </td>
                    <td className="py-3 px-4 text-start whitespace-nowrap">{user.applications}</td>
                    <td className="py-3 px-4 text-start whitespace-nowrap relative">
                      <button onClick={() => handleMore(user)} className="hover:bg-gray-100 rounded-full">
                        <CgMoreVertical />
                      </button>
                      {activeUser === user?.id && (
                        <ul className="absolute top-6 right-12 w-36 bg-white shadow-md rounded-lg px-2 py-1 transform transition-all duration-200 ease-in-out animate-dropdown">
                          <li
                            onClick={() => handleView(user?.id)}
                            className="cursor-pointer hover:text-blue-200 mb-2 p-2"
                          >
                            view
                          </li>
                        </ul>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>

        {/* basic search */}
        {!loading && !candidateError && searchResult === null && hasSearchParams && (
          <div className="flex items-start justify-center gap-6 flex-wrap">
            {candidateData?.length ? (
              candidateData.map((data, index) => <CandidateCard seeker={data} key={index} />)
            ) : (
              <div className="col-span-full text-center py-12">
                <BiUser className="mx-auto h-16 w-16 text-gray-300" />
                <h3 className="mt-4 text-lg font-medium text-gray-900">No candidates found</h3>
                <p className="mt-1 text-gray-500">Try adjusting your search filters for more results.</p>
              </div>
            )}
          </div>
        )}
      </div>

      <FooterComponent />
    </div>
  );
};

export default Candidate;